import * as React from 'react';
import { billingAmmounts } from '../../../../const/billingAmmounts';

export function BillingAmounts({ amount, onSelect }) {
    return <div className="billing-amounts">
        {billingAmmounts.map(amountEl => {
            return <div className={`billing-amounts__item ${+amount === +amountEl.value ? 'selected' : ''}`} key={amountEl.value} onClick={() => {
                onSelect(+amountEl.value);
            }}>
                $&nbsp;<b>{amountEl.title}</b>
            </div>;
        })}
    </div>;
}